module.exports = __webpack_public_path__ + "img/zujuan.05e6963d.png";